import { getIterableArrayOfObjects } from 'shared/utils/getIterableArrayOfObjects';

import { architectureTab, balconiesTab, floorToCeilingWindowsTab, lobbyTab, terracesTab, yardParkTab } from './tabs';
import { type SeriaPlusTabScheme } from './seriaPlusTypes';

export const tabs = getIterableArrayOfObjects<SeriaPlusTabScheme>([
  floorToCeilingWindowsTab,
  balconiesTab,
  terracesTab,
  lobbyTab,
  yardParkTab,
  architectureTab,
]);
